const VisibilityState = {
	VISIBLE: "visible",
	NONE: "none"
};
export default VisibilityState;
